/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationStatus } from '../models/ApplicationStatus';
import type { AssignLicensingAgencyRequest } from '../models/AssignLicensingAgencyRequest';
import type { AutonomousVehicleRegistrationStatus } from '../models/AutonomousVehicleRegistrationStatus';
import type { BusinessEntity } from '../models/BusinessEntity';
import type { BusinessEntitySort } from '../models/BusinessEntitySort';
import type { BusinessStructure } from '../models/BusinessStructure';
import type { CertificateStatus } from '../models/CertificateStatus';
import type { CreateBusinessEntityUserRequest } from '../models/CreateBusinessEntityUserRequest';
import type { CreateBusinessEntityUserResponse } from '../models/CreateBusinessEntityUserResponse';
import type { ExportFormat } from '../models/ExportFormat';
import type { GetBusinessEntityHistoryResponse } from '../models/GetBusinessEntityHistoryResponse';
import type { GetBusinessEntityUserResult } from '../models/GetBusinessEntityUserResult';
import type { LicensingAgency } from '../models/LicensingAgency';
import type { ListBusinessEntitiesResponse } from '../models/ListBusinessEntitiesResponse';
import type { ListBusinessEntityUsersResult } from '../models/ListBusinessEntityUsersResult';
import type { MccsRoles } from '../models/MccsRoles';
import type { SortDirection } from '../models/SortDirection';
import type { UpdateBusinessEntityRequest } from '../models/UpdateBusinessEntityRequest';
import type { UpdateBusinessEntityUserRequest } from '../models/UpdateBusinessEntityUserRequest';
import type { UserSort } from '../models/UserSort';
import type { VinHistoryResponse } from '../models/VinHistoryResponse';
import type { VinSearchResponse } from '../models/VinSearchResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BusinessEntityService {
  /**
   * List/search business entities, filtering by various criteria. NOTE: This only returns business entities the user has access to
   * @param query
   * @param autonomousVehicleStatus
   * @param certificateStatus
   * @param applicationStatus
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @param format
   * @returns ListBusinessEntitiesResponse OK
   * @throws ApiError
   */
  public static list(
    query?: string,
    autonomousVehicleStatus?: Array<AutonomousVehicleRegistrationStatus>,
    certificateStatus?: Array<CertificateStatus>,
    applicationStatus?: Array<ApplicationStatus>,
    limit?: number,
    offset?: number,
    sortBy?: BusinessEntitySort,
    sortDirection?: SortDirection,
    format?: ExportFormat,
  ): CancelablePromise<ListBusinessEntitiesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/BusinessEntity',
      query: {
        'query': query,
        'autonomousVehicleStatus': autonomousVehicleStatus,
        'certificateStatus': certificateStatus,
        'applicationStatus': applicationStatus,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
        'format': format,
      },
    });
  }
  /**
   * Get a single business entity by ID. NOTE: This only returns business entities the user has access to
   * @param id
   * @returns BusinessEntity OK
   * @throws ApiError
   */
  public static get(
    id: string,
  ): CancelablePromise<BusinessEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/BusinessEntity/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * Update one or more fields for a business entity.
   * @param id
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static update(
    id: string,
    requestBody?: UpdateBusinessEntityRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/BusinessEntity/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Search historical vehicle records by full or partial VIN. NOTE: This only returns companies the user has access to
   * @param vin
   * @param limit
   * @param offset
   * @returns VinSearchResponse OK
   * @throws ApiError
   */
  public static searchByVin(
    vin: string,
    limit?: number,
    offset?: number,
  ): CancelablePromise<VinSearchResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/BusinessEntity/search/vin',
      query: {
        'vin': vin,
        'limit': limit,
        'offset': offset,
      },
    });
  }
  /**
   * Get every company historically associated with a VIN. NOTE: This only returns companies the user has access to
   * @param vin
   * @returns VinHistoryResponse OK
   * @throws ApiError
   */
  public static getVinHistory(
    vin: string,
  ): CancelablePromise<VinHistoryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/BusinessEntity/search/vin/{vin}',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * Save a certificate holder's business information: business type, owner details, TIN/FEIN, and the partners or officers its business type uses.
   * @param businessEntityId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static saveBusinessInformation(
    businessEntityId: string,
    requestBody?: BusinessStructure,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/BusinessEntity/{businessEntityId}/business-information',
      path: {
        'businessEntityId': businessEntityId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Create a user for a specific business entity. This will find or create the user, and grant them the requested role(s) on the business entity.
   * @param businessEntityId
   * @param requestBody
   * @returns CreateBusinessEntityUserResponse Created
   * @throws ApiError
   */
  public static createUser(
    businessEntityId: string,
    requestBody?: CreateBusinessEntityUserRequest,
  ): CancelablePromise<CreateBusinessEntityUserResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/BusinessEntity/{businessEntityId}/users',
      path: {
        'businessEntityId': businessEntityId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * List users for a specific business entity.
   * @param businessEntityId
   * @param query
   * @param role
   * @param enabled
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @param format
   * @returns ListBusinessEntityUsersResult OK
   * @throws ApiError
   */
  public static listUsers(
    businessEntityId: string,
    query?: string,
    role?: Array<MccsRoles>,
    enabled?: boolean,
    limit?: number,
    offset?: number,
    sortBy?: UserSort,
    sortDirection?: SortDirection,
    format?: ExportFormat,
  ): CancelablePromise<ListBusinessEntityUsersResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/BusinessEntity/{businessEntityId}/users',
      path: {
        'businessEntityId': businessEntityId,
      },
      query: {
        'query': query,
        'role': role,
        'enabled': enabled,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
        'format': format,
      },
    });
  }
  /**
   * Update a business entity user by their unique identifier.
   * @param businessEntityId
   * @param userId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static updateUser(
    businessEntityId: string,
    userId: string,
    requestBody?: UpdateBusinessEntityUserRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/BusinessEntity/{businessEntityId}/users/{userId}',
      path: {
        'businessEntityId': businessEntityId,
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get a specific user for a business entity.
   * @param businessEntityId
   * @param userId
   * @returns GetBusinessEntityUserResult OK
   * @throws ApiError
   */
  public static getUser(
    businessEntityId: string,
    userId: string,
  ): CancelablePromise<GetBusinessEntityUserResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/BusinessEntity/{businessEntityId}/users/{userId}',
      path: {
        'businessEntityId': businessEntityId,
        'userId': userId,
      },
    });
  }
  /**
   * Remove a user from a specific business entity. This does not delete the user, only removes their association with the business entity.
   * @param businessEntityId
   * @param userId
   * @returns void
   * @throws ApiError
   */
  public static removeUser(
    businessEntityId: string,
    userId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/BusinessEntity/{businessEntityId}/users/{userId}',
      path: {
        'businessEntityId': businessEntityId,
        'userId': userId,
      },
    });
  }
  /**
   * Retrieve a licensing agency role for a specific business entity and role. This is used to check the assigned licensing agency for a role (MC user, AV User, etc.).
   * @param businessEntityId
   * @param role
   * @returns LicensingAgency OK
   * @throws ApiError
   */
  public static getLicensingAgency(
    businessEntityId: string,
    role: MccsRoles,
  ): CancelablePromise<LicensingAgency> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/BusinessEntity/{businessEntityId}/licensing-agencies/{role}',
      path: {
        'businessEntityId': businessEntityId,
        'role': role,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Assign a licensing agency role to a user for a specific business entity and role. This is used to grant a specific role (MC user, AV User, etc.) to a licensing agency  .
   * @param businessEntityId
   * @param role
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static assignLicensingAgency(
    businessEntityId: string,
    role: MccsRoles,
    requestBody?: AssignLicensingAgencyRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/BusinessEntity/{businessEntityId}/licensing-agencies/roles/{role}',
      path: {
        'businessEntityId': businessEntityId,
        'role': role,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Revoke a licensing agency role from a user for a specific business entity and role. This is used to remove a specific role (MC user, AV User, etc.) from a licensing agency  .
   * @param businessEntityId
   * @param role
   * @returns void
   * @throws ApiError
   */
  public static revokeLicensingAgency(
    businessEntityId: string,
    role: MccsRoles,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/BusinessEntity/{businessEntityId}/licensing-agencies/roles/{role}',
      path: {
        'businessEntityId': businessEntityId,
        'role': role,
      },
    });
  }
  /**
   * Get the change history for a business entity by its id.
   * @param businessEntityId
   * @returns GetBusinessEntityHistoryResponse OK
   * @throws ApiError
   */
  public static getHistory(
    businessEntityId: string,
  ): CancelablePromise<GetBusinessEntityHistoryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/BusinessEntity/{businessEntityId}/history',
      path: {
        'businessEntityId': businessEntityId,
      },
    });
  }
}
